import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  getJobsGetData:[],
  notificationData: [],
  SingleJobNotification:[],
  enquiryData:[],
  deleteEnquiryData:[],
  isOpenModal: false,
  selectedEventId: null,
  selectedRange: null,
  EnquiryLikeData:[],
  SendReplyData:[],
  notificationListData:[],
  deleteNotificationListData:[]
};

const slice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET EVENTS  
    getNotificationSucc(state, action) {
      state.isLoading = false;
      state.notificationData = action.payload;
    },
    getSingleJobNotification(state, action) {
      state.isLoading = false;
      state.SingleJobNotification = action.payload;
    },
    getEnquirySucc(state, action){
      state.isLoading = false;
      state.enquiryData = action.payload;
    },
    DeleteEnquirySucc(state, action){
      state.isLoading = false;
      state.deleteEnquiryData = action.payload;
    },
    EnquiryLikeSucc(state, action){
      state.isLoading = false;
      state.EnquiryLikeData = action.payload;
    },
    SendReplyEnquiry(state, action){
      state.isLoading = false;
      state.SendReplyData = action.payload;
    },
    getNotificationListRes(state, action){
      state.isLoading = false;
      state.notificationListData = action.payload;
    },
    deleteNotificationListRes(state, action){
      state.isLoading = false;
      state.deleteNotificationListData = action.payload;
    },
    getJobsValues(state, action) {
      state.isLoading = false;
      state.getJobsGetData = action.payload;
    },
    
    // postSkillSetSucc(state, action) {
    //     state.isLoading = false;
    //     state.PostSkillSetData = action.payload;
    //   },
   
   // CREATE EVENT
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { openModal, closeModal, selectEvent } = slice.actions;

// ----------------------------------------------------------------------

export function getJobsData(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/get_job_notification/',data);
      if (response && response.data && response.data.status === 200) {
        dispatch(slice.actions.getJobsValues(response.data));
      } else {
        dispatch(slice.actions.hasError(response.data));
      }
    } catch (error) {
      if (error && error.status !== '' && error.status !== undefined) {
        dispatch(slice.actions.hasError(error));
      } else {
        dispatch(slice.actions.hasError({ status: '502', message: 'Something went wrong' }));
      }
    }
  };
}

export function getSingleJobNotification(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/get_single_job_notification/',data);
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.getSingleJobNotification(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
      } catch (error) {
        if((error && error.status !== "") && (error.status !== undefined) ){
          dispatch(slice.actions.hasError(error));
       } else{
        dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
      }
    }
  };
}

export function getNotificationData() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/get_job_notification/');
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.getNotificationSucc(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
      } catch (error) {
        if((error && error.status !== "") && (error.status !== undefined) ){
          dispatch(slice.actions.hasError(error));
       } else{
        dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
      }
    }
  };
}

export function DoEnquiryLike(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/like_enquiry/',data);
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.EnquiryLikeSucc(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
    } catch (error) {
      if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
     } else{
      dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
    }
    }
  };
}

export function ClearDoEnquiryLike(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.EnquiryLikeSucc([]));
    
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEnquiryData(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/get_enquiry/');
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.getEnquirySucc(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
    } catch (error) {
      if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
     } else{
      dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
    }
    }
  };
}
export function DeleteEnquiryData(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/delete_enquiry/',data);
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.DeleteEnquirySucc(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
    } catch (error) {
      if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
     } else{
      dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
    }
    }
  };
}

export function clearDeleteEnquiryData(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.DeleteEnquirySucc([]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function SendReplyToPost(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/reply_enquiry/',data);
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.SendReplyEnquiry(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
    } catch (error) {
      if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
     } else{
      dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
    }
    }
  };
}

export function ClearSendReplyToPost(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.SendReplyEnquiry([]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getNotificationList(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/get_notification/');
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.getNotificationListRes(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
    } catch (error) {
      if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
     } else{
      dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
    }
    }
  };
}

export function deleteNotificationList(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/delete_notification/',data);
      if(response && response.data && response.data.status === 200 ){
        dispatch(slice.actions.deleteNotificationListRes(response.data));
        } else{
        dispatch(slice.actions.hasError(response.data)) 
      }
    } catch (error) {
      if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
     } else{
      dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
    }
    }
  };
}

export function clearDeleteNotificationList(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.deleteNotificationListRes([]));
     
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function clearHasError(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.hasError([]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
